import { render, staticRenderFns } from "./AboutAwards.vue?vue&type=template&id=07cf8335&scoped=true"
import script from "./AboutAwards.vue?vue&type=script&lang=js"
export * from "./AboutAwards.vue?vue&type=script&lang=js"
import style0 from "./AboutAwards.vue?vue&type=style&index=0&id=07cf8335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf8335",
  null
  
)

export default component.exports